// src/services/extractContract.js
//
// Browser-side helper(s) to extract contract fields.
// This file runs in Vite/React. No Deno/TS here.

import { supabase } from "../lib/supabase";

/**
 * Low-level call to the Edge Function directly (optional).
 */
export async function extractContract(payload = {}) {
  const { data, error } = await supabase.functions.invoke("extract-contract", {
    body: payload,
  });

  if (error) {
    console.error("[extractContract] Edge Function error:", {
      name: error.name,
      message: error.message,
      context: error.context,
      details: error.details,
    });
    throw error;
  }

  return data;
}

/**
 * Function expected by AddOfferModal.jsx
 * Uses your existing PDF pipeline in pdfParserService.js.
 *
 * This avoids relying on a specific named export.
 */
export async function extractContractFromFile(file, options = {}) {
  if (!file) throw new Error("extractContractFromFile: file is required");

  // Import the whole module so we can support default export OR named export
  const pdfMod = await import("./pdfParserService");

  // Try common patterns:
  // 1) named export extractContractFieldsWithOpenAI
  // 2) default export is a function
  // 3) default export is an object containing the function
  // 4) named export extractContractFromFile (sometimes the service already has it)
  const fn =
    pdfMod.extractContractFieldsWithOpenAI ||
    pdfMod.extractContractFromFile ||
    (typeof pdfMod.default === "function" ? pdfMod.default : null) ||
    (pdfMod.default && typeof pdfMod.default.extractContractFieldsWithOpenAI === "function"
      ? pdfMod.default.extractContractFieldsWithOpenAI
      : null) ||
    (pdfMod.default && typeof pdfMod.default.extractContractFromFile === "function"
      ? pdfMod.default.extractContractFromFile
      : null);

  if (typeof fn !== "function") {
    const keys = Object.keys(pdfMod || {});
    const defaultKeys = pdfMod?.default && typeof pdfMod.default === "object" ? Object.keys(pdfMod.default) : [];
    throw new Error(
      `pdfParserService does not export a usable extraction function. ` +
        `Found exports: [${keys.join(", ")}] defaultKeys: [${defaultKeys.join(", ")}]`
    );
  }

  // Run existing pipeline
  return await fn(file, options);
}